
import { Trans } from "../utils/i18n";

export function getAppointmentStatusTranslation(item) {
    if(item.status === 'cancelled') {
        return (
            <span className={'inline-block bg-red-500 rounded-xl text-white px-1'}>
                <Trans i18nKey="appointment.status.cancelled">Cancelled</Trans>
            </span>
        );
    }
    if(item.status === 'customerNotAvailable') {
        return (<span className={'inline-block px-1 rounded-xl bg-yellow-500'}>
            <Trans i18nKey="appointment.status.customerNotAvailable">Customer was not available</Trans>
        </span>
        );
    }
    if(item.status === 'completed') {
        return(
            <span className={'inline-block px-1 rounded-xl bg-green-500 text-white'}>
                <Trans i18nKey="appointment.status.completed">Completed</Trans>
            </span>
        );
    }
    if(item.status === 'open') {
        return (
            <span className={'inline-block px-1 rounded-xl bg-blue-300'}>
                <Trans i18nKey="appointment.status.open">Open</Trans>
            </span>
        );
    }
    if(item.status === 'failed') {
        return (
            <span className={'inline-block px-1 rounded-xl bg-red-600 text-white'}>
                <Trans i18nKey="appointment.status.failed">Failed</Trans>
            </span>
        );
    }
    return (
        <span className={'inline-block p-0.5'}>{item.status}</span>
    );
}
